const getCacheKey = (cabinetId?: number | string) =>
    cabinetId ? `cabinet_preview_${cabinetId}` : '';

export const getCachedPreviewImage = (cabinetId?: number | string) => {
    try {
        const key = getCacheKey(cabinetId);
        if (!key) return '';
        return sessionStorage.getItem(key) ?? '';
    } catch {
        return '';
    }
};

export const setCachedPreviewImage = (
    cabinetId: number | string | undefined,
    dataUrl: string
) => {
    try {
        const key = getCacheKey(cabinetId);
        if (!key || !dataUrl) return;
        sessionStorage.setItem(key, dataUrl);
    } catch {
        // ignore storage errors
    }
};
